export const getRiskLevel = (rate, limit, { withOk = true } = {}) => {
  if (!rate) return "zero"
  if (!limit) return "neutral"
  if (rate >= limit) return "error"
  if (rate >= limit / 2) return "warning"
  return withOk ? "ok" : "neutral"
}

export const HIGHLIGHTED_RISK_LEVELS = ["error", "warning", "ok"]

export const formatRiskTooltip = ({ rateName, rate, limitName, limit }) =>
  `${rateName} ${Number(rate).toFixed(2)}% · ${limitName} ${Number(limit).toFixed(2)}%`
